import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const scannerHeight = 340;

export const useStyles = makeStyles()((theme: Theme) => ({
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBlock: theme.spacing(5),
    },
    addedDeviceContainer: {
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: theme.palette.emteria.background.paper,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        borderRadius: 4,
    },
    addedDeviceRow: {
        display: "flex",
        gap: theme.spacing(1),
        alignItems: "flex-end",
    },
    addedDeviceLabel: {
        width: 90,
    },
    addedDeviceIconContainer: {
        display: "flex",
        alignItems: "center",
    },
    modalContent: {
        display: "flex",
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        flex: 1,
    },
    formButtonContainer: {
        display: "flex",
        justifyContent: "flex-end",
    },
    manualFields: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        minHeight: scannerHeight,
    },
    scannerLoading: {
        height: scannerHeight,
    },
    cameraError: {
        height: scannerHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
        padding: theme.spacing(3),
        textAlign: "center",
        borderWidth: 1,
        borderColor: theme.palette.emteria.border.secondary,
        borderStyle: "solid",
        borderRadius: 4,
        color: theme.palette.emteria.text.secondary,
    },
    modeSwitch: {
        marginTop: "auto",
    },
    backIcon: {
        marginRight: theme.spacing(1),
    },
    devicesList: {
        flex: 1,
        borderWidth: 1,
        borderColor: theme.palette.emteria.border.secondary,
        borderStyle: "solid",
        borderRadius: 4,
        overflow: "auto",
        padding: theme.spacing(1),
    },
    emptyDevicesList: {
        flex: 1,
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.emteria.text.secondary,
    },
    addedDeviceIconError: {
        color: theme.palette.emteria.error,
    },
    addedDeviceIconSuccess: {
        color: theme.palette.emteria.success,
    },
}));
